import { createContext } from 'react';
import { ICreateSupervisionContext } from '../interfaces/get-supervision.interfaces';

export const CreateSupervisionContext = createContext({} as ICreateSupervisionContext);
